import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * 業種マスタを読む唯一の入口。
 *
 * 申し込み画面と店舗設定の3箇所が、存在しない 'businessTypes' を
 * 直接読んでいた。件数0はエラーにならないので、
 * 「業種の欄が空で先へ進めない」という形でしか表に出ない。
 * 実体は category_masters（scripts/init-master-data.js が入れる場所）。
 */

export interface BusinessCategoryOption {
  id: string;
  code: string;
  /** 表示名（言語に応じて解決済み） */
  name: string;
  icon: string;
  sortOrder: number;
}

type Lang = 'ja' | 'en' | 'th' | 'zh-TW' | 'ko';

/** name は多言語オブジェクトのことも、ただの文字列のこともある */
function resolveName(raw: unknown, lang: Lang): string {
  if (typeof raw === 'string') return raw;
  if (raw && typeof raw === 'object') {
    const m = raw as Record<string, string>;
    return m[lang] ?? m.ja ?? m.en ?? Object.values(m)[0] ?? '';
  }
  return '';
}

export async function fetchBusinessCategories(lang: Lang = 'ja'): Promise<BusinessCategoryOption[]> {
  const snap = await getDocs(query(
    collection(db, 'category_masters'),
    where('isActive', '==', true),
    orderBy('sortOrder')
  ));
  return snap.docs.map((d) => {
    const v = d.data() as any;
    return {
      id: d.id,
      code: v.code ?? d.id,
      name: resolveName(v.name, lang),
      icon: v.icon ?? '',
      sortOrder: v.sortOrder ?? 0,
    };
  });
}
